import styled from 'styled-components';
import { Text, TextProps } from 'components/Typography';
import { getThemeColor } from 'utils/styled';
import { LinkStyleProps } from './types';

// have to assert Text type here otherwise TextProps's `variant` overrides that of
// LinkStyleProps, making it difficult to get the right types for `variant`
export const Root = styled(
  Text as React.FC<Omit<TextProps, 'variant'>>,
)<LinkStyleProps>`
  background-color: transparent;
  border: none;
  padding: 0;
  transition: ${(props) =>
    props.theme.transitions.create(['color', 'opacity'])};

  &:not([aria-disabled='true']) {
    cursor: pointer;
  }

  &,
  &[data-hovered='true'] {
    text-decoration: none;
  }

  ${({ variant }) =>
    variant === 'inherit' &&
    `
    font-family: inherit;
    font-size: inherit;
    font-weight: bold;
    letter-spacing: inherit;
    line-height: inherit;
  `};

  &,
  &:visited {
    color: ${(props) =>
      props.inheritColor ? 'inherit' : getThemeColor('actionPrimary')};
  }

  &[data-hovered='true'] {
    color: ${(props) =>
      props.inheritColor ? 'inherit' : getThemeColor('actionPrimary', 'dark')};
  }

  &[aria-disabled='true'] {
    opacity: 0.35;
  }
`;
